import { render, staticRenderFns } from "./HomeMake.vue?vue&type=template&id=12ed7d9d&scoped=true&"
import script from "./HomeMake.vue?vue&type=script&lang=js&"
export * from "./HomeMake.vue?vue&type=script&lang=js&"
import style0 from "./HomeMake.vue?vue&type=style&index=0&id=12ed7d9d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ed7d9d",
  null
  
)

export default component.exports